const prefix = "speedtestUI.";

export interface IStorage {
    getItem(key: string): string | null;
    setItem(key: string, value: string): void;
}

export type StorageKind = "local" | "session";

const storageDic = new Map<StorageKind, IStorage>();

export const getVolatileStorage = (kind: StorageKind): IStorage => {
    if (!storageDic.has(kind)) {
        storageDic.set(kind, new VolatileStorage());
    }

    return storageDic.get(kind)!;
}

export enum Keys {
    LastModemSwapDisplay = "LastModemSwapDisplay",
    PrivacyPolicyAccepted = "PrivacyPolicyAccepted",
    FcData = "adv_fcData"
}

export const fullKey = (k: Keys): string => {
    return prefix + k;
}

class VolatileStorage implements IStorage {
    private data = new Map<string, string | null>();

    getItem(key: string) {
        const r = this.data.get(key);
        return r === undefined ? null : r;
    }

    setItem(key: string, value: string) {
        this.data.set(key, value);
    }
}
